module.exports = __webpack_public_path__ + "img/sub2.a2bfef34.png";